import { render } from "./EventTemplateDialog.vue?vue&type=template&id=4714e352"
import script from "./EventTemplateDialog.vue?vue&type=script&lang=js"
export * from "./EventTemplateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__